import React, { Component, useState } from "react";
import "./TotalCss.css";
import { Row, Col, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import { api_url } from "./globalFunction/global_string";
import { SiteTitle } from "./SiteTitle";
import { FetchDataExcel } from "./FetchDataExcel";
import { FetchDataExcelNet } from "./FetchDataExcelNet";
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { SelectNet } from "./BasicComponents/SelectNet";
import { SelectName } from "./BasicComponents/SelectName";
import { SelectUnitproxyApply } from "./BasicComponents/SelectUnitproxyApply";
import { SelectUnit } from "./BasicComponents/SelectUnit";

export class SiteExcel extends Component {
  static displayName = SiteExcel.name;

  constructor(props) {
    super(props);
    this.state = {
      showModal: false, //初始化 modal 關閉
      isFetchDataExcel: '',
      local_net_id: '',
      local_net_name: '',
      local_unit_id: '',
      local_unit_name: '',
      opcallity: '', //重要性
      url_name: '',
      url_addr: '',
      dynamicData: [],
      showTable: true,
      checked: false,
      currentPage: 1,
      itemsPerPage: 15,
      fetchDataForTableExcel: {
        parentName: "SiteExcel",
        current_user_type: localStorage.getItem('login_user_type'),
        local_net_id: localStorage.getItem('login_user_net_id'),
        local_unit_id: localStorage.getItem('login_user_unit_id'),
        user_id: localStorage.getItem('login_user_id'),
        user_name: localStorage.getItem('login_user_name'),
        fetchDataExcelApi: api_url + "/api/JRCC/GetLocalUserUrl",
      },
      fetchDataForTableProxyExcel: {
        current_user_type: localStorage.getItem('login_user_type'),
        local_net_id: localStorage.getItem('login_user_net_id'),
        local_unit_id: localStorage.getItem('login_user_unit_id'),
        user_id: localStorage.getItem('login_user_id'),
        user_name: localStorage.getItem('login_user_name'),
        fetchDataExcelProxyApi: api_url + "/api/JRCC/GetLocalProxyUserUrl",
      }
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange() {
    this.setState(prevState => ({
      checked: !prevState.checked,
      currentMode: !prevState.checked ? 'proxy' : 'scan'
    }), () => {
      this.useridDomaintable();
    });
  }


  componentDidMount() {
    this.setState({ current_user_type: localStorage.getItem('login_user_type') });
    this.setState({ local_net_id: localStorage.getItem('login_user_net_id') });
    this.setState({ local_net_name: localStorage.getItem('login_user_net_name') });
    this.setState({ local_unit_id: localStorage.getItem('login_user_unit_id') });
    this.setState({ local_unit_name: localStorage.getItem('login_user_unit_name') });
    this.setState({ user_id: localStorage.getItem('login_user_id') });
    this.setState({ user_name: localStorage.getItem('login_user_name') });
    this.setState({ isFetchDataExcel: true });
    this.useridDomaintable();
  }
  componentDidUpdate(prevProps, prevState) {

    if (this.state.checked !== prevState.checked) {
      // console.log('Checked state has changed.');
      this.resetFetchDataApplyNet();
    }

    if (this.state.selectnet !== prevState.selectnet) {
      console.log("selectnet changed from", prevState.selectnet, "to", this.state.selectnet);

      this.resetSelectNetChange();
    }
  }
  resetFetchDataApplyNet = () => {
    this.setState({
      selectnet: '',
      selectedUnitproxy: '',
      selecteduser: '',
    });
  }
  resetSelectNetChange = () => {
    console.log("resetSelectNetChange called");
    // 除了重置 selectedUnitproxy 和 local_unit_proxy_name
    // 如果还有其他状态与 SelectUnitproxyApply 组件相关，也应该在这里重置
    this.setState({
      selectedUnitproxy: '',
      local_unit_proxy_name: '',
      selectedName: '',
      options: []  // 假设这是与 SelectUnitproxyApply 组件相关的选项列表状态
    });
  };

  handleOptionChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    let apiUrl;
    let trimmedUrlName = this.state.url_name.trim();
    let trimmedUrlAddr = this.state.url_addr.trim();

    if (trimmedUrlName === '' || trimmedUrlAddr === '') {
      Swal.fire({
        icon: 'warning',
        title: '網站名稱或網址不能為空',
      });
      return;
    }
    const formData = new FormData();
    if (this.state.checked === false) {
      formData.append("current_user_type", this.state.current_user_type);
      formData.append("local_unit_id", this.state.local_unit_id);
      formData.append("local_net_id", this.state.local_net_id);
      formData.append("Url_addr", trimmedUrlAddr);
      formData.append("Url_name", trimmedUrlName);
      formData.append("Opcallity", this.state.opcallity);
      formData.append("user_id", this.state.user_id);
      formData.append("user_name", this.state.user_name);
      apiUrl = api_url + "/api/JRCC/PostLocalUrlId";
    } else if (this.state.fetchDataForTableProxyExcel.current_user_type === 'S' && this.state.checked === true) {
      formData.append("local_unit_id", this.state.selectedUnitproxy);
      formData.append("local_net_id", this.state.selectnet);
      formData.append("Url_addr", trimmedUrlAddr);
      formData.append("Url_name", trimmedUrlName);
      formData.append("Opcallity", this.state.opcallity);
      formData.append("user_id", this.state.selecteduser);
      formData.append("user_name", this.state.local_user_name);
      apiUrl = api_url + "/api/JRCC/PostProxyUrl";
    } else if (this.state.fetchDataForTableProxyExcel.current_user_type === 'M' && this.state.checked === true) {
      formData.append("local_unit_id", this.state.selectedUnitproxy);
      formData.append("local_net_id", this.state.fetchDataForTableProxyExcel.local_net_id);
      formData.append("Url_addr", trimmedUrlAddr);
      formData.append("Url_name", trimmedUrlName);
      formData.append("Opcallity", this.state.opcallity);
      formData.append("user_id", this.state.selecteduser);
      formData.append("user_name", this.state.local_user_name);
      apiUrl = api_url + "/api/JRCC/PostProxyUrl";
    }
    fetch(apiUrl,
      {
        method: "POST",
        headers: {
          "Authorization": localStorage.getItem('accessToken'),
        },
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        let arr_status = [String(data.statusCode), data.row, data.detail] //api 回傳判斷
        if (arr_status[0] === "200") {
          this.setState({
            url_name: '',
            url_addr: '',
            opcallity: '',
            betaversion: ''
          }, () => {
            //console.log(this.state);
          });

          this.setState({ isFetchDataExcel: false }, () => {
            this.setState({ isFetchDataExcel: true });
          });

          Swal.fire({
            icon: 'success',
            title: '【新增成功】',
            text: '資料已成功儲存'
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: `【${arr_status[1]}】`,
          });
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }

  //匯入EXCEL檔案
  handleExcel = () => {
    const formData = new FormData();
    const fileInput = document.getElementById('formFile');
    const selectedFile = fileInput.files[0];
    let apiUrl;
    if (!selectedFile) {
      Swal.fire({
        icon: 'warning',
        title: '【請上傳EXCEL檔案】',
      });
      return;
    }
    if (this.state.checked === true) {
      if (!this.state.selecteduser) {
        Swal.fire({
          icon: 'warning',
          title: '請選擇人員資料',
        });
        return;
      }
    }

    if (this.state.checked === false) {
      apiUrl = api_url + "/api/JRCC/PostLocalUrlEXCELReference";
      formData.append('excelFile', selectedFile);
      formData.append('current_user_type', this.state.current_user_type);
      formData.append('Local_net_id', this.state.local_net_id);
      formData.append('Local_unit_id', this.state.local_unit_id);
    } else if (this.state.fetchDataForTableProxyExcel.current_user_type === 'S' && this.state.checked === true) {
      formData.append("local_unit_id", this.state.selectedUnitproxy);
      formData.append("local_net_id", this.state.selectnet);
      formData.append("Opcallity", this.state.opcallity);
      formData.append("user_id", this.state.selecteduser);
      formData.append("user_name", this.state.local_user_name);
      formData.append('excelFile', selectedFile);
      formData.append('current_user_type', this.state.current_user_type);
      apiUrl = api_url + "/api/JRCC/PostProxyLocalUrlEXCELReference";
    } else if (this.state.fetchDataForTableProxyExcel.current_user_type === 'M' && this.state.checked === true) {
      formData.append("local_unit_id", this.state.selectedUnitproxy);
      formData.append("local_net_id", this.state.fetchDataForTableProxyExcel.local_net_id);
      formData.append("Opcallity", this.state.opcallity);
      formData.append("user_id", this.state.selecteduser);
      formData.append("user_name", this.state.local_user_name);
      formData.append('excelFile', selectedFile);
      formData.append('current_user_type', this.state.current_user_type);
      apiUrl = api_url + "/api/JRCC/PostProxyLocalUrlEXCELReference";
    }

    fetch(apiUrl, {
      method: "POST",
      headers: {
        "Authorization": localStorage.getItem('accessToken'),
      },
      body: formData
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        let arr_status = [String(data.statusCode), data.row, data.detail] //api 回傳判斷
        if (arr_status[0] === "200") {
          this.setState({
            url_name: '',
            url_addr: '',
            opcallity: '',
          }, () => {
            //console.log(this.state);
          });

          this.setState({ isFetchDataExcel: false }, () => {
            this.setState({ isFetchDataExcel: true });
          });


          Swal.fire({
            icon: 'success',
            title: '【新增成功】',
            text: '資料已成功儲存'
          }).then(() => {
            document.getElementById('formFile').value = null;
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: `【${arr_status[1]}】`,
          });
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  toggleTable = () => {
    this.setState(prevState => ({
      showTable: !prevState.showTable
    }));
  };

  useridDomaintable = async () => {
    const formData = new FormData();
    let apiUrl;

    if (this.state.checked === false) {
      formData.append("user_type", this.state.fetchDataForTableExcel.current_user_type);
      formData.append("loacl_net_id", this.state.fetchDataForTableExcel.local_net_id);
      formData.append("user_id", this.state.fetchDataForTableExcel.user_id);
      apiUrl = api_url + "/api/Async/GetDomainData";
    } else {
      formData.append("user_type", this.state.fetchDataForTableExcel.current_user_type);
      formData.append("loacl_net_id", this.state.selectnet);
      formData.append("user_id", this.state.selecteduser);
      apiUrl = api_url + "/api/Async/GetProxyDomainData";
    }

    await fetch(apiUrl, {
      method: "POST",
      headers: { "Authorization": localStorage.getItem('accessToken') },
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        if (data && Array.isArray(data.row)) {
          this.setState({ dynamicData: data.row, loading: false });
        } else {
          console.error('Received data.row is not an array');
        }
      })
      .catch(error => {
        console.log('Error fetching JSON:', error);
      });
  }

  nextPage = () => {
    const totalPage = Math.ceil(this.state.dynamicData.length / this.state.itemsPerPage);
    if (this.state.currentPage < totalPage) {
      this.setState({ currentPage: this.state.currentPage + 1 });
    }
  }

  prevPage = () => {
    if (this.state.currentPage > 1) {
      this.setState({ currentPage: this.state.currentPage - 1 });
    }
  }

  handleDownload = async () => {
    const fileName = '教育體系網站弱點掃描服務網址匯入範本.xlsx';
    const fileUrl = `${api_url}/${fileName}`;

    const response = await fetch(fileUrl);
    const blob = await response.blob();

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }


  //以下的資料是代理模式使用
  // 處理網域選擇
  handleNetSelectChange = (data) => {
    const { value, selectedName } = data;
    console.log("handleNetSelectChange: value", value);
    if (!value || value === '') {
      this.setState({
        selectnet: '',
        local_net_name: '',
        local_user_name: '',
        dynamicData: [],
        selectedUnitproxy: '',
        local_unit_proxy_name: '',
      });
    } else {
      this.setState({ selectnet: value, local_net_name: selectedName });
    }
  };

  // 處理人員選擇
  handleUserSelectChange = (data) => {
    const { value, selectedName } = data;
    if (!value || value === '') {
      this.setState({
        selecteduser: '',
        local_user_name: '',
        dynamicData: []
      });
    } else {
      this.setState({ selecteduser: value, local_user_name: selectedName }, () => {
        this.useridDomaintable();
      });
    }
  };

  // 處理單位選擇變更事件
  handleUnitSelectChange = (data) => {
    console.log(data);
    const { value, selectedName } = data;

    this.setState(prevState => ({
      selectedUnit: value,
      local_unit_name: selectedName,
    }), () => {
      //.log("Selected unit updated:", this.state.selectedUnit, this.state.local_unit_name);
    });
  };
  // 處理單位名稱
  SelectUnitproxyApply = (data) => {
    const { value, selectedName } = data;
    if (!value || value === '') {
      this.setState({
        selectedUnitproxy: '',
        local_unit_proxy_name: '',
        local_user_name: '',
        dynamicData: []
      });
    } else {
      this.setState({ selectedUnitproxy: value, local_unit_proxy_name: selectedName });
    }
  };

  render() {
    let filteredData = [];
    const userType = localStorage.getItem('login_user_type');
    const net_name = localStorage.getItem('login_user_net_name');
    let FormDataUsertype;
    if (this.state.fetchDataForTableExcel.current_user_type === 'M' || this.state.fetchDataForTableExcel.current_user_type === 'S') {
      filteredData = this.state.dynamicData;
    } else {
      filteredData = this.state.dynamicData.filter(
        item => item.user_id === this.state.fetchDataForTableExcel.user_id
      );
    }
    // 分頁邏輯
    const indexOfLastItem = this.state.currentPage * this.state.itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - this.state.itemsPerPage;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const totalPage = Math.ceil(filteredData.length / this.state.itemsPerPage);

    const tableRows = currentItems.map((item, index) => (
      <tr key={index}>
        <td>{indexOfFirstItem + index + 1}</td>
        <td>{item.domain}</td>
      </tr>
    ));

    if (userType === 'S') {
      if (this.state.checked === false) {
        FormDataUsertype = (
          <div>
            <Button onClick={this.toggleTable}>網域資料表格</Button>
            {this.state.showTable && (
              <div>
                <table className="customTable table-bordered">
                  <thead>
                    <tr>
                      <th>編號</th>
                      <th>可新增之網域</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableRows}
                  </tbody>
                </table>
                <div className="pagination-buttons">
                  <button className="btn-pagination" disabled={this.state.currentPage <= 1} onClick={this.prevPage}>上一頁</button>
                  <span className="total-items">總共有 {filteredData.length} 筆</span>
                  <button className="btn-pagination" disabled={this.state.currentPage >= totalPage} onClick={this.nextPage}>下一頁</button>
                </div>
              </div>
            )}
            <Form>
              {/* <FormGroup row inline>
                <Label for="local_net_id" sm={2}>區網名稱</Label>
                <Col sm={10}>
                  <SelectNet
                    parentName={'superS'}
                    id={'excel_net_name'}
                    name={'excel_net_name'}
                    requiredAPI={'/api/JRCC/GetLocalNetId'}
                    handleNetSelectChange={this.handleNetSelectChange}
                  />
                </Col>
              </FormGroup>
              <FormGroup row inline>
                <Label for="excel_unit_proxy_name" sm={2}>單位名稱</Label>
                <Col sm={10}>
                  <SelectUnitproxyApply
                    parentName={'superS'}
                    id={'excel_unit_proxy_name'}
                    name={'excel_unit_proxy_name'}
                    requiredAPI={'/api/Async/GetNetDownUnitlist'}
                    SelectUnitproxyApply={this.SelectUnitproxyApply}
                    selectnet={this.state.selectnet}
                    local_net_name={this.state.local_net_name}
                  />
                </Col>
              </FormGroup> */}
              <FormGroup row inline>
                <Label for="url_name" sm={2}>申請 網站名</Label>
                <Col sm={10}>
                  <Input type="text" id="url_name" name="url_name" className="form-control col-lg-6 col-md-8 mx-1 my-2" value={this.state.url_name} onChange={this.handleOptionChange} />
                </Col>
              </FormGroup>
              <FormGroup row inline>
                <Label for="url_addr" sm={2}>申請 網址</Label>
                <Col sm={10}>
                  <Input type="text" id="url_addr" name="url_addr" className="form-control col-lg-6 col-md-8 mx-1 my-2" value={this.state.url_addr} onChange={this.handleOptionChange} />
                </Col>
              </FormGroup>
              <FormGroup tag="fieldset">
                <Row>
                  <Label sm={2}>重要性</Label>
                  <Col sm={3}>
                    <FormGroup check>
                      <Label check>
                        <Input
                          type="radio"
                          name="opcallity"
                          value="1"
                          checked={this.state.opcallity === '1'}
                          onChange={this.handleOptionChange}
                        />{' '}
                        普
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col sm={3}>
                    <FormGroup check>
                      <Label check>
                        <Input
                          type="radio"
                          name="opcallity"
                          value="2"
                          checked={this.state.opcallity === '2'}
                          onChange={this.handleOptionChange}
                        />{' '}
                        中
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col sm={3}>
                    <FormGroup check>
                      <Label check>
                        <Input
                          type="radio"
                          name="opcallity"
                          value="3"
                          checked={this.state.opcallity === '3'}
                          onChange={this.handleOptionChange}
                        />{' '}
                        高
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>
              </FormGroup>


            </Form>
          </div>
        );
      }
      else {
        FormDataUsertype = (
          <div>
            <Button onClick={this.toggleTable}>{this.state.local_user_name}網域資料表格</Button>
            {this.state.showTable && (
              <div>
                <table className="customTable table-bordered">
                  <thead>
                    <tr>
                      <th>編號</th>
                      <th>可新增之網域</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableRows}
                  </tbody>
                </table>
                <div className="pagination-buttons">
                  <button className="btn-pagination" disabled={this.state.currentPage <= 1} onClick={this.prevPage}>上一頁</button>
                  <span className="total-items">總共有 {filteredData.length} 筆</span>
                  <button className="btn-pagination" disabled={this.state.currentPage >= totalPage} onClick={this.nextPage}>下一頁</button>
                </div>
              </div>
            )}
            <Form>
              <FormGroup row inline>
                <Label for="local_net_id" sm={2}>區網名稱</Label>
                <Col sm={10}>
                  <SelectNet
                    parentName={'superS'}
                    id={'excel_net_name'}
                    name={'excel_net_name'}
                    requiredAPI={'/api/JRCC/GetLocalNetId'}
                    handleNetSelectChange={this.handleNetSelectChange}
                  />
                </Col>
              </FormGroup>
              <FormGroup row inline>
                <Label for="excel_unit_proxy_name" sm={2}>單位名稱</Label>
                <Col sm={10}>
                  <SelectUnitproxyApply
                    key={this.state.selectnet}
                    parentName={'superS'}
                    id={'excel_unit_proxy_name'}
                    name={'excel_unit_proxy_name'}
                    requiredAPI={'/api/Async/GetNetDownUnitlist'}
                    SelectUnitproxyApply={this.SelectUnitproxyApply}
                    selectnet={this.state.selectnet}
                    local_net_name={this.state.local_net_name}
                  />
                </Col>
              </FormGroup>
              <FormGroup row inline>
                <Label for="local_user_id" sm={2}>人員資料</Label>
                <Col sm={10}>
                  <SelectName
                    parentName={'superS'}
                    id={'excel_user_name'}
                    name={'excel_user_name'}
                    requiredAPI={'/api/Async/GetUserdatalist'}
                    handleUserSelectChange={this.handleUserSelectChange}
                    selectedUnitproxy={this.state.selectedUnitproxy}
                    local_unit_proxy_name={this.state.local_unit_proxy_name}
                    selectnet={this.state.selectnet}
                    local_net_name={this.state.local_net_name}
                  />
                </Col>
              </FormGroup>
              <FormGroup row inline>
                <Label for="url_name" sm={2}>申請 網站名</Label>
                <Col sm={10}>
                  <Input type="text" id="url_name" name="url_name" className="form-control col-lg-6 col-md-8 mx-1 my-2" value={this.state.url_name} onChange={this.handleOptionChange} />
                </Col>
              </FormGroup>
              <FormGroup row inline>
                <Label for="url_addr" sm={2}>申請 網址</Label>
                <Col sm={10}>
                  <Input type="text" id="url_addr" name="url_addr" className="form-control col-lg-6 col-md-8 mx-1 my-2" value={this.state.url_addr} onChange={this.handleOptionChange} />
                </Col>
              </FormGroup>
              <FormGroup tag="fieldset">
                <Row>
                  <Label sm={2}>重要性</Label>
                  <Col sm={3}>
                    <FormGroup check>
                      <Label check>
                        <Input
                          type="radio"
                          name="opcallity"
                          value="1"
                          checked={this.state.opcallity === '1'}
                          onChange={this.handleOptionChange}
                        />{' '}
                        普
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col sm={3}>
                    <FormGroup check>
                      <Label check>
                        <Input
                          type="radio"
                          name="opcallity"
                          value="2"
                          checked={this.state.opcallity === '2'}
                          onChange={this.handleOptionChange}
                        />{' '}
                        中
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col sm={3}>
                    <FormGroup check>
                      <Label check>
                        <Input
                          type="radio"
                          name="opcallity"
                          value="3"
                          checked={this.state.opcallity === '3'}
                          onChange={this.handleOptionChange}
                        />{' '}
                        高
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>
              </FormGroup>
            </Form>
          </div>
        );
      }
    } else if (userType === 'M') {
      if (this.state.checked === false) {
        FormDataUsertype = (
          <div>
            <Button onClick={this.toggleTable}>網域資料表格</Button>
            {this.state.showTable && (
              <div>
                <table className="customTable table-bordered">
                  <thead>
                    <tr>
                      <th>編號</th>
                      <th>可新增之網域</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableRows}
                  </tbody>
                </table>
                <div className="pagination-buttons">
                  <button className="btn-pagination" disabled={this.state.currentPage <= 1} onClick={this.prevPage}>上一頁</button>
                  <span className="total-items">總共有 {filteredData.length} 筆</span>
                  <button className="btn-pagination" disabled={this.state.currentPage >= totalPage} onClick={this.nextPage}>下一頁</button>
                </div>
              </div>
            )}
            <Form>
              {/* <FormGroup row inline>
                <Label for="excel_unit_name" sm={2}>單位名稱</Label>
                <Col sm={10}>
                  <SelectUnit
                    parentName={'Excel'}
                    id={'excel_unit_name'}
                    name={'excel_unit_name'}
                    requiredAPI={'/api/JRCC/GetLocalUnitId'}
                    onUnitSelectChange={this.handleUnitSelectChange}
                  />
                </Col>
              </FormGroup> */}
              <FormGroup row inline>
                <Label for="url_name" sm={2}>申請 網站名</Label>
                <Col sm={10}>
                  <Input type="text" id="url_name" name="url_name" className="form-control col-lg-6 col-md-8 mx-1 my-2" value={this.state.url_name} onChange={this.handleOptionChange} />
                </Col>
              </FormGroup>
              <FormGroup row inline>
                <Label for="url_addr" sm={2}>申請 網址</Label>
                <Col sm={10}>
                  <Input type="text" id="url_addr" name="url_addr" className="form-control col-lg-6 col-md-8 mx-1 my-2" value={this.state.url_addr} onChange={this.handleOptionChange} />
                </Col>
              </FormGroup>

              <FormGroup tag="fieldset">
                <Row>
                  <Label sm={2}>重要性</Label>
                  <Col sm={3}>
                    <FormGroup check>
                      <Label check>
                        <Input
                          type="radio"
                          name="opcallity"
                          value="1"
                          checked={this.state.opcallity === '1'}
                          onChange={this.handleOptionChange}
                        />{' '}
                        普
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col sm={3}>
                    <FormGroup check>
                      <Label check>
                        <Input
                          type="radio"
                          name="opcallity"
                          value="2"
                          checked={this.state.opcallity === '2'}
                          onChange={this.handleOptionChange}
                        />{' '}
                        中
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col sm={3}>
                    <FormGroup check>
                      <Label check>
                        <Input
                          type="radio"
                          name="opcallity"
                          value="3"
                          checked={this.state.opcallity === '3'}
                          onChange={this.handleOptionChange}
                        />{' '}
                        高
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>
              </FormGroup>
            </Form>
          </div>
        )
      } else {
        FormDataUsertype =
          (<div>
            <Button onClick={this.toggleTable}>{this.state.local_user_name}網域資料表格</Button>
            {this.state.showTable && (
              <div>
                <table className="customTable table-bordered">
                  <thead>
                    <tr>
                      <th>編號</th>
                      <th>可新增之網域</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableRows}
                  </tbody>
                </table>
                <div className="pagination-buttons">
                  <button className="btn-pagination" disabled={this.state.currentPage <= 1} onClick={this.prevPage}>上一頁</button>
                  <span className="total-items">總共有 {filteredData.length} 筆</span>
                  <button className="btn-pagination" disabled={this.state.currentPage >= totalPage} onClick={this.nextPage}>下一頁</button>
                </div>
              </div>
            )}
            <Form>
              <FormGroup row inline>
                <Label sm={2}>區網名稱</Label>
                <Col sm={10}>
                  <span className="form-control-plaintext">{net_name}</span>
                </Col>
              </FormGroup>
              <FormGroup row inline>
                <Label for="excel_unit_proxy_name" sm={2}>單位名稱</Label>
                <Col sm={10}>
                  <SelectUnitproxyApply
                    parentName={'superM'}
                    id={'excel_unit_proxy_name'}
                    name={'excel_unit_proxy_name'}
                    requiredAPI={'/api/Async/GetNetDownUnitlist'}
                    SelectUnitproxyApply={this.SelectUnitproxyApply}
                    selectnet={this.state.fetchDataForTableProxyExcel.local_net_id}
                    local_net_name={net_name}
                  />
                </Col>
              </FormGroup>
              <FormGroup row inline>
                <Label for="local_user_id" sm={2}>人員資料</Label>
                <Col sm={10}>
                  <SelectName
                    parentName={'superM'}
                    id={'excel_user_name'}
                    name={'excel_user_name'}
                    requiredAPI={'/api/Async/GetUserdatalist'}
                    handleUserSelectChange={this.handleUserSelectChange}
                    selectedUnitproxy={this.state.selectedUnitproxy}
                    local_unit_proxy_name={this.state.local_unit_proxy_name}
                    selectnet={this.state.fetchDataForTableProxyExcel.local_net_id}
                    local_net_name={net_name}
                  />
                </Col>
              </FormGroup>
              <FormGroup row inline>
                <Label for="url_name" sm={2}>申請 網站名</Label>
                <Col sm={10}>
                  <Input type="text" id="url_name" name="url_name" className="form-control col-lg-6 col-md-8 mx-1 my-2" value={this.state.url_name} onChange={this.handleOptionChange} />
                </Col>
              </FormGroup>
              <FormGroup row inline>
                <Label for="url_addr" sm={2}>申請 網址</Label>
                <Col sm={10}>
                  <Input type="text" id="url_addr" name="url_addr" className="form-control col-lg-6 col-md-8 mx-1 my-2" value={this.state.url_addr} onChange={this.handleOptionChange} />
                </Col>
              </FormGroup>
              <FormGroup tag="fieldset">
                <Row>
                  <Label sm={2}>重要性</Label>
                  <Col sm={3}>
                    <FormGroup check>
                      <Label check>
                        <Input
                          type="radio"
                          name="opcallity"
                          value="1"
                          checked={this.state.opcallity === '1'}
                          onChange={this.handleOptionChange}
                        />{' '}
                        普
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col sm={3}>
                    <FormGroup check>
                      <Label check>
                        <Input
                          type="radio"
                          name="opcallity"
                          value="2"
                          checked={this.state.opcallity === '2'}
                          onChange={this.handleOptionChange}
                        />{' '}
                        中
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col sm={3}>
                    <FormGroup check>
                      <Label check>
                        <Input
                          type="radio"
                          name="opcallity"
                          value="3"
                          checked={this.state.opcallity === '3'}
                          onChange={this.handleOptionChange}
                        />{' '}
                        高
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>
              </FormGroup>

            </Form>
          </div>
          )
      }
    }
    else if (userType === 'N') {
      FormDataUsertype = (
        <div>
          <Button onClick={this.toggleTable}>網域資料表格</Button>
          {this.state.showTable && (
            <div>
              <table className="customTable table-bordered">
                <thead>
                  <tr>
                    <th>編號</th>
                    <th>可新增之網域</th>
                  </tr>
                </thead>
                <tbody>
                  {tableRows}
                </tbody>
              </table>
              <div className="pagination-buttons">
                <button className="btn-pagination" disabled={this.state.currentPage <= 1} onClick={this.prevPage}>上一頁</button>
                <span className="total-items">總共有 {filteredData.length} 筆</span>
                <button className="btn-pagination" disabled={this.state.currentPage >= totalPage} onClick={this.nextPage}>下一頁</button>
              </div>
            </div>
          )}
          <Form>
            <FormGroup row inline>
              <Label for="url_name" sm={2}>申請 網站名</Label>
              <Col sm={10}>
                <Input type="text" id="url_name" name="url_name" className="form-control col-lg-6 col-md-8 mx-1 my-2" value={this.state.url_name} onChange={this.handleOptionChange} />
              </Col>
            </FormGroup>
            <FormGroup row inline>
              <Label for="url_addr" sm={2}>申請 網址</Label>
              <Col sm={10}>
                <Input type="text" id="url_addr" name="url_addr" className="form-control col-lg-6 col-md-8 mx-1 my-2" value={this.state.url_addr} onChange={this.handleOptionChange} />
              </Col>
            </FormGroup>
            <FormGroup tag="fieldset">
              <Row>
                <Label sm={2}>重要性</Label>
                <Col sm={3}>
                  <FormGroup check>
                    <Label check>
                      <Input
                        type="radio"
                        name="opcallity"
                        value="1"
                        checked={this.state.opcallity === '1'}
                        onChange={this.handleOptionChange}
                      />{' '}
                      普
                    </Label>
                  </FormGroup>
                </Col>
                <Col sm={3}>
                  <FormGroup check>
                    <Label check>
                      <Input
                        type="radio"
                        name="opcallity"
                        value="2"
                        checked={this.state.opcallity === '2'}
                        onChange={this.handleOptionChange}
                      />{' '}
                      中
                    </Label>
                  </FormGroup>
                </Col>
                <Col sm={3}>
                  <FormGroup check>
                    <Label check>
                      <Input
                        type="radio"
                        name="opcallity"
                        value="3"
                        checked={this.state.opcallity === '3'}
                        onChange={this.handleOptionChange}
                      />{' '}
                      高
                    </Label>
                  </FormGroup>
                </Col>
              </Row>
            </FormGroup>
          </Form>
        </div>

      )
    }

    return (
      <div>
        <div className="mt-5">
          <h1 id="tableLabel" className='mb-3'>檢測網站匯入</h1>
          {(userType === 'S' || userType === 'M') && (
            <button
              className={this.state.checked ? "button-switch on" : "button-switch off"}
              onClick={this.handleChange}>
              {this.state.checked ? "代理模式" : "掃描模式"}
            </button>
          )}
          <div id="site_manage" className="row col-12 mb-5">
            <div className="row justify-content-center">
              <div className="row col-sm-12 col-md-10 col-lg-8 rounded-3 d-inline-flex justify-content-center align-content-center mt-4">
                {FormDataUsertype}
              </div>
              <div className="row col-sm-12 col-md-10 col-lg-8 rounded-3 d-inline-flex justify-content-center align-content-center skin-white ">
                <Button type="submit" className="btn btn-primary col-md-2 col-lg-1 mx-1 my-2" onClick={this.handleSubmit}>新增</Button>
                {
                  <>
                    <Button type="submit_excel" className="btn btn-danger col-md-2 col-lg-1 mx-1 my-2" onClick={this.handleExcel}>匯入</Button>
                    <input class="form-control" type="file" id="formFile" className="col-md-4 col-lg-3 mx-1 my-2 py-1" />
                    <a download className="col-md-2 col-lg-1 mx-1 my-2" onClick={this.handleDownload}>
                      <FontAwesomeIcon icon={faFileExcel} size="2x" />
                    </a>
                  </>
                }
              </div>
            </div>
          </div>
          {this.state.isFetchDataExcel && (
            <>
              {(userType === 'S' && this.state.checked === true) && (
                <FetchDataExcelNet
                  fetchDataForTableProxyExcel={this.state.fetchDataForTableProxyExcel}
                  selectnet={this.state.selectnet}
                  local_net_name={this.state.local_net_name}
                  selectedUnitproxy={this.state.selectedUnitproxy}
                  selecteduser={this.state.selecteduser}
                />
              )}
              {(userType === 'M' && this.state.checked === true) && (
                <FetchDataExcelNet
                  fetchDataForTableProxyExcel={this.state.fetchDataForTableProxyExcel}
                  selectnet={this.state.fetchDataForTableProxyExcel.local_net_id}
                  local_net_name={net_name}
                  selectedUnitproxy={this.state.selectedUnitproxy}
                  selecteduser={this.state.selecteduser}
                />
              )}
              {((userType === 'M' || userType === 'N' || userType === 'S') && this.state.checked === false) && (
                <FetchDataExcel
                  fetchDataForTableExcel={this.state.fetchDataForTableExcel}
                  selectnet={this.state.selectnet}
                  selectedUnitproxy={this.state.selectedUnitproxy}
                  selectedUnit={this.state.selectedUnit}
                />
              )}
            </>
          )}
        </div>
      </div>
    )
  }
}